import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'

const linkCss = css`
  &,
  &:active,
  &:visited,
  &:focus {
    color: ${colors.text.secondary} !important;
    font-size: 0.875rem;
    line-height: 1.35;
    margin-right: 25px;
    display: inline-block;
    cursor: pointer;
    background: transparent;
    border: none;
    font-family: Verdana, Ayuthaya, sans-serif;
  }

  &:hover {
    text-decoration: underline;
    color: ${colors.text.secondary};
  }
`

const linkButtonCss = css`
  ${linkCss};
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
`

const cookiePreferencesLinkCss = css`
  a {
    ${linkCss}
  }
`

export default function NavLink({ id, href, to, text, external, ...props }) {
  if (id === 'cookiePreferences') {
    return <span id={id} css={cookiePreferencesLinkCss} {...props} />
  }
  if (!href && !to) {
    // see https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/anchor-is-valid.md
    return (
      <button type="button" css={linkButtonCss} {...props}>
        {text}
      </button>
    )
  }
  if (to) {
    return (
      <Link to={to} noLinkStyles css={linkCss} {...props}>
        {text}
      </Link>
    )
  }
  return (
    <a href={href} css={linkCss} {...props}>
      {text}
    </a>
  )
}

NavLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  id: PropTypes.string,
  to: PropTypes.string,
}
